import React, { useEffect, useState } from 'react';
import { Form, Button } from 'react-bootstrap';

function DiscountPopover({ onSubmit, onCancel, discountRow }) {
    const [selectedDiscountType, setSelectedDiscountType] = useState('amount');
    const [percentageValue, setPercentageValue] = useState('');

    const handleRadioChange = (val) => setSelectedDiscountType(val);
    const handleInputChange = (e) => setPercentageValue(e.target.value);

    useEffect(() => {
        setSelectedDiscountType(discountRow?.discount_type)
        setPercentageValue(discountRow?.percentage)
    }, [discountRow])

    const handleSubmit = () => {
        onSubmit(selectedDiscountType, percentageValue);
    };

    return (
        <Form>
            <div className="d-flex align-items-center gap-2">
                <Form.Check
                    type="radio"
                    name="option"
                    id="option1"
                    value="Percentage"
                    label="Percentage"
                    checked={selectedDiscountType === 'percentage'}
                    onChange={() => handleRadioChange('percentage')}
                    className="form-check-inline"
                />
                {/* <Form.Control
                    type="text"
                    size="sm"
                    value={percentageValue}
                    onChange={handleInputChange}
                    placeholder=""
                    style={{ width: '50' }}
                />
                <span style={{ whiteSpace: 'nowrap' }}>%</span> */}
            </div>
            <div className="d-flex justify-content-start gap-2">
            <Form.Check
                type="radio"
                name="option"
                id="option2"
                value="Direct Price Reduction"
                label="Direct Price Reduction"
                checked={selectedDiscountType === 'amount'}
                onChange={() => handleRadioChange('amount')}
                className="form-check-inline ml-auto"
            />
               </div>
           <div className="d-flex justify-content-start gap-2">
                <button type="button" className="btn btn-primary btn-blue me-1"
                    onClick={handleSubmit}>
                    <span>Save</span>
                </button>
                <button type="button" className="btn btn-outline-primary btn-blue"
                    onClick={onCancel}>
                    <span>Cancel</span>
                </button>
            </div>
        </Form>
    );
}

export default DiscountPopover;